var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.show
    ? _c(
        "v-container",
        { attrs: { fluid: "" } },
        [
          _c(
            "v-dialog",
            {
              attrs: { "max-width": "800px", scrollable: "" },
              model: {
                value: _vm.show,
                callback: function ($$v) {
                  _vm.show = $$v
                },
                expression: "show",
              },
            },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-card-title",
                    {
                      staticClass:
                        "secondary white--text d-flex align-center justify-space-between",
                    },
                    [
                      _c(
                        "span",
                        {
                          staticClass: "header-font",
                          staticStyle: { "font-size": "22px" },
                        },
                        [
                          _vm._v(
                            "\n          " + _vm._s(_vm.title) + "\n        "
                          ),
                        ]
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-subtitle",
                    {
                      staticClass:
                        "secondary py-2 white--text d-flex align-center justify-space-between",
                    },
                    [
                      _c("span", { staticClass: "subheader-font body-2" }, [
                        _vm._v(_vm._s(_vm.subtitle)),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-text",
                    { staticClass: "py-0" },
                    [
                      _c(
                        "section",
                        { staticClass: "d-flex justify-center mt-5" },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass:
                                "elevation-0 monospace-font px-4 me-2",
                              attrs: {
                                small: "",
                                color: "secondary",
                                rounded: "",
                                outlined: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.onClearClick()
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("general.clear")))]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              staticClass:
                                "elevation-0 monospace-font white--text px-4",
                              attrs: {
                                small: "",
                                color: "secondary",
                                rounded: "",
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.onSelectAllClick()
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$t("finishingMap.selectAll")))]
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.isVertical
                        ? _c("FieldAreaSelector", {
                            ref: "fieldAreaSelectorRef",
                            attrs: {
                              areas: _vm.currentUserAreas,
                              fieldColor: _vm.currentUserFieldColor,
                              isVertical: true,
                            },
                            on: {
                              areaToggle: function ($event) {
                                return _vm.onAreaToggle($event)
                              },
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isHorizontal ||
                      (!_vm.isVertical && !_vm.isFullWidth && !_vm.isGoal)
                        ? _c("FieldAreaSelector", {
                            ref: "fieldAreaSelectorRef",
                            attrs: {
                              areas: _vm.currentUserAreas,
                              fieldColor: _vm.currentUserFieldColor,
                            },
                            on: {
                              areaToggle: function ($event) {
                                return _vm.onAreaToggle($event)
                              },
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isFullWidth
                        ? _c("FieldAreaSelector", {
                            ref: "fieldAreaSelectorRef",
                            attrs: {
                              areas: _vm.currentUserAreas,
                              fieldColor: _vm.currentUserFieldColor,
                            },
                            on: {
                              areaToggle: function ($event) {
                                return _vm.onAreaToggle($event)
                              },
                            },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isGoal
                        ? _c(
                            "v-img",
                            {
                              ref: "pitchImg",
                              staticClass: "my-5",
                              style: {
                                position: "relative",
                                width: "100%",
                                aspectRatio: "2 / 1",
                              },
                              attrs: {
                                src: require(`@/assets/img/front_goal.png`),
                                contain: "",
                              },
                            },
                            _vm._l(_vm.goalAreas, function (area) {
                              return _c(
                                "div",
                                { key: area.id },
                                [
                                  _c(
                                    "v-tooltip",
                                    {
                                      attrs: {
                                        top: "",
                                        color: "lightSecondary lighten-4",
                                        "max-width": "300",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "activator",
                                            fn: function ({ on, attrs }) {
                                              return [
                                                _c(
                                                  "v-btn",
                                                  _vm._g(
                                                    _vm._b(
                                                      {
                                                        key: area.id,
                                                        staticClass:
                                                          "area-toggle",
                                                        style:
                                                          _vm.getButtonStyle(
                                                            area
                                                          ),
                                                        attrs: {
                                                          color: area.selected
                                                            ? "primary"
                                                            : "grey lighten-2",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.toggleGoalArea(
                                                              area.id
                                                            )
                                                          },
                                                        },
                                                      },
                                                      "v-btn",
                                                      attrs,
                                                      false
                                                    ),
                                                    on
                                                  )
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        true
                                      ),
                                    },
                                    [
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "black--text body-1" },
                                        [_vm._v(_vm._s(area.label))]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              )
                            }),
                            0
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.selectedAreas.length
                        ? _c(
                            "section",
                            {
                              staticClass:
                                "d-flex align-center justify-start flex-wrap",
                            },
                            [
                              _c(
                                "span",
                                {
                                  staticClass:
                                    "body-1 font-weight-bold primary--text ms-2",
                                },
                                [_vm._v("Selected areas: ")]
                              ),
                              _vm._v(" "),
                              _vm._l(_vm.selectedAreas, function (area, i) {
                                return _c(
                                  "v-chip",
                                  {
                                    key: i,
                                    staticClass: "body-1 ma-1 black--text",
                                    attrs: {
                                      small: "",
                                      color: "lightSecondary lighten-2",
                                    },
                                  },
                                  [
                                    _c(
                                      "span",
                                      { staticClass: "font-weight-medium" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            area.label ||
                                              _vm.$t(
                                                `videoHighlights.areas.${area.name}`
                                              )
                                          )
                                        ),
                                      ]
                                    ),
                                  ]
                                )
                              }),
                            ],
                            2
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-card-actions",
                    { staticClass: "pr-6 pb-4 d-flex justify-end" },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "elevation-0 monospace-font px-4",
                          attrs: {
                            color: _vm.$vuetify.theme.dark
                              ? "white"
                              : "secondary darken-1",
                            rounded: "",
                            outlined: "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.onCancelClick()
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("general.cancel")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          staticClass:
                            "elevation-0 monospace-font white--text px-4",
                          attrs: { rounded: "", color: "primary" },
                          on: {
                            click: function ($event) {
                              return _vm.onConfirmClick()
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("general.confirm")))]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }